import PropTypes from 'prop-types';
import React from 'react';
import { Wrapper } from './TagList.styles';
import Badge from '../../Badge';
import Tooltip from '../../Tooltip';

const buildBadgeList = (badges, limit) => {
  const result = badges.map((badge, index) => {
    if ((limit && index + 1 <= limit) || !limit) {
      return <Badge label={badge} size="medium" />;
    }

    return <></>;
  });

  if (limit && badges.length - limit > 0) {
    result.push(
      <Tooltip placement="top" arrow title={badges.slice(limit).join(', ')}>
        <span>
          <Badge label={`+${badges.length - limit}`} />
        </span>
      </Tooltip>,
    );
  }

  return result;
};

export const BadgeList = (props, limit, tagComponent) => {
  let value;
  if (Array.isArray(props)) {
    value = buildBadgeList(props, limit, tagComponent);
  } else if (Array.isArray(props.cell.value)) {
    value = buildBadgeList(props.cell.value, limit, tagComponent);
  } else {
    // eslint-disable-next-line no-console
    console.error(
      'Value provided for `BadgeList` cell component is not accepted',
    );
  }

  return <Wrapper>{value}</Wrapper>;
};

BadgeList.propTypes = {
  cell: PropTypes.object.isRequired,
};
